import { usePageTour } from './usePageTour';
import { useWelcomeTour } from './useWelcomeTour';

type TourHostProps = {
    userId: string;
    /** Sayfa turlarinin otomatik acilisi acik mi? (orn. yonetici icin `false`) */
    pageToursEnabled: boolean;
};

/**
 * Turlari yoneten gorunmez bilesen; ana yerlesimde bir kez kullanilir.
 * Karsilama turu sayfalar arasinda gezdigi icin sayfalarin disinda yasar.
 */
const TourHost = ({ userId, pageToursEnabled }: TourHostProps) => {
    useWelcomeTour({ userId });
    usePageTour({ userId, enabled: pageToursEnabled });
    return null;
};

export default TourHost;
